import { RenderWithFeaturePriority } from '@web/components/RenderWithFeaturePriority/RenderWithFeaturePriority';
import { SignalCoreInterceptor } from './SignalCore';
import { SignalIntentInterceptor } from './SignalIntent';
import { SignalTargetingInterceptor } from './SignalTargeting';

/**
 * To call correct signal agent's api based on the feature enabled, and call this component in the root of the app(only once)
 */
export const SignalsInterceptor = () => {
  return (
    <RenderWithFeaturePriority
      rules={[
        {
          condition: { features: ['signal-targeting', 'signal-intent'] },
          component: <SignalCoreInterceptor />,
          priority: 1,
        },
        {
          condition: { features: ['signal-targeting'] },
          component: <SignalTargetingInterceptor />,
          priority: 2,
        },
        {
          condition: { features: ['signal-intent'] },
          component: <SignalIntentInterceptor />,
          priority: 3,
        },
      ]}
    />
  );
};
